import { COLORS } from '@/constants';
import { Accordion, AccordionSummary } from '@mui/material';

import styled from 'styled-components';

export const List = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const StyledImage = styled.img<{ $isHidden?: boolean }>`
  width: 36px;
  height: 36px;
  border-radius: 6px;
  border-width: 1px;
  border: 1px solid ${COLORS['neutral/200']};
  flex-shrink: 0;

  object-fit: contain;

  display: ${({ $isHidden }) => ($isHidden ? 'none' : 'block')};
`;

export const Item = styled(Accordion)`
  &.MuiAccordion-root {
    border-radius: 10px !important;
    box-shadow: none;
    border: 1px solid ${COLORS['neutral/300']};

    &::before {
      display: none;
    }

    &.Mui-expanded {
      margin: 0;
    }
  }
  & .MuiAccordionDetails-root {
    padding: 16px 12px;
    color: ${COLORS['neutral/900']};
  }

  & .MuiAccordionSummary-root {
    padding: 0 6px;
  }
`;

export const ItemHead = styled(AccordionSummary)`
  &.MuiAccordionSummary-root {
    min-height: 0;
    background: ${COLORS['neutral/50']};
    border-radius: 10px;
    justify-content: space-between;
    &.Mui-expanded {
      border-bottom: 1px solid ${COLORS['neutral/300']};
      min-height: 0;
      border-radius: 0;
      border-top-left-radius: 10px;
      border-top-right-radius: 10px;
    }
    & .MuiAccordionSummary-content {
      margin: 6px 0px;
      &.Mui-expanded {
        margin: 6px 0px;
      }
    }
  }
`;

export const ItemBrokerBox = styled.div`
  display: flex;
  gap: 12px;
  max-width: 90%;
`;

export const ItemBrokerDesc = styled.div`
  display: flex;
  flex-direction: column;
  gap: 3px;
`;

export const ItemField = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
`;

export const ItemContent = styled.div`
  display: flex;
  gap: 14px;
  flex-direction: column;
`;

export const ItemContentRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  gap: 14px;
  justify-content: space-between;
  align-items: flex-end;
  align-content: flex-start;
`;

export const ItemContentCheckboxesBox = styled.div`
  display: flex;
  gap: 16px;
`;

export const ItemContentCheckboxItem = styled.div`
  display: flex;
  gap: 6px;
  align-items: center;
`;

export const WhatsAppElement = styled.div`
  height: 28px;
  border: 2px solid #5bbb5b;
  color: #5bbb5b;
  padding: 0px 6px;
  border-radius: 6px;
  display: flex;
  gap: 4px;
  align-items: center;
  flex-shrink: 0;

  svg {
    width: 16px;
    height: 16px;

    path {
      stroke: #5bbb5b !important;
      fill: #5bbb5b !important;
    }
  }
`;

export const HeadIconBox = styled.div`
  display: flex;
  gap: 4px;
  align-items: center;
`;
